export class ProductHashTagCommandModel {
    public productHashTagId: string;
    public hashTagId: string;
    public displaySequence: number;
}
